module.exports = __webpack_public_path__ + "files/c95688b22ff4b1c09172f25923abcff0.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/custom-1.png
// module id = 1158
// module chunks = 76